import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { FieldArray, formValueSelector, reduxForm } from 'redux-form'
// components
import { Divider } from '@mui/material'
import { ReduxSwitch } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// view components
import ResultRow from './components/ResultRow'
import PeriodRow from './components/PeriodRow'
import DefaultTarget from './components/DefaultTarget'
// views
import { Header } from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'
// views
import { ButtonsWrapper, Paper } from './views'
// themes
import { CloseIcon } from 'components/UI/Icons'
// constants
import { Forms } from 'constants/index'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'

const resultFormSelector = formValueSelector(Forms.KPI_RESULT_TARGETS_FORM)

interface Props {
  width: string
  hideModal: () => void
  isLoading: boolean
  targetForm: string
}

const ResultTargetForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  width,
  hideModal,
  isLoading,
  targetForm,
  handleSubmit
}) => {
  const { differentTargets } = useSelector((state) => ({
    differentTargets: resultFormSelector(state, 'differentTargets')
  }))

  return (
    <Paper component={'form'} onSubmit={handleSubmit} width={width}>
      <Header>
        <span>Result Targets</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ReduxSwitch name={'differentTargets'} label={'Apply different result target range across all indicator periods?'} />
      <Divider />

      {differentTargets ? (
        <Scrollbar>
          <DefaultTarget targetForm={targetForm} />
          <FieldArray component={PeriodRow} name={'differentResults'} rerenderOnEveryChange targetForm={targetForm} />
        </Scrollbar>
      ) : (
        <Scrollbar>
          <FieldArray component={ResultRow} name={'results'} rerenderOnEveryChange targetForm={targetForm} />
        </Scrollbar>
      )}

      <ButtonsWrapper>
        <Button type={'submit'} isLoading={isLoading} layout={BUTTON_LAYOUTS.PURPLE} shadowLess>
          Save
        </Button>
        <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Paper>
  )
}

export default reduxForm<any, Props>({ form: Forms.KPI_RESULT_TARGETS_FORM })(ResultTargetForm)
